import { render, staticRenderFns } from "./ClientHistoryContainer.vue?vue&type=template&id=0dbbb589&"
import script from "./ClientHistoryContainer.vue?vue&type=script&lang=js&"
export * from "./ClientHistoryContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports